import { selectReportUiUrl } from 'util/selector/apiSelector';

export namespace ExternalRoute {
  export const EmployeeInfo =
    'https://workbuzzkb.zendesk.com/hc/en-gb/articles/27578564090898-Adding-Employees-via-Upload';
  export const DepartmentInfo =
    'https://intercom-help.eu/workbuzz/en/articles/743203-how-to-update-your-department-structure-via-file-upload' as const;
  export const ProjectReportSummary = `${selectReportUiUrl()}/:id/home/summary` as const;
}
